const typography = {
  fonts: {
    sans: `"DM Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`
  },
  fontSizes: {
    md: '1rem'
  },
  lineHeights: {
    md: '1.5rem'
  },
  texts: {
    md: {
      fontSize: 'md',
      lineHeight: 'md'
    }
  }
}

export type ITypography = typeof typography

export default typography
